module.exports = __webpack_public_path__ + "assets/img/thumb-AIF---Australian-Institute-of-Fitness-Page-Resource.21fcf089.webp";